/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StandardResponse
 */
export interface StandardResponse {
    /**
     * 
     * @type {string}
     * @memberof StandardResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the StandardResponse interface.
 */
export function instanceOfStandardResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StandardResponseFromJSON(json: any): StandardResponse {
    return StandardResponseFromJSONTyped(json, false);
}

export function StandardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StandardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function StandardResponseToJSON(value?: StandardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

